import React from 'react'

import InputNumber from 'components/input-number'
import { Wrapper, InputNumberLabel } from 'components/layout/form'

import { FieldContainer, InputField } from './styled'

const InputNumberElement = ({
  id,
  value,
  onChange,
  handleChangePlus,
  handleChangeMinus,
  isMinusButtonDisabled,
  isPlusButtonDisabled,
  border,
  mainLabel,
  secondLabel,
  e2eClass,
  label,
  restrictions
}) => (
  <Wrapper noPadding={!label}>
    {label && <InputNumberLabel e2eClass={e2eClass}>{label}</InputNumberLabel>}
    <FieldContainer border={border} fieldId={id} e2eClass={e2eClass}>
      <InputField>
        {mainLabel}
        {secondLabel}
      </InputField>
      <InputNumber
        id={id}
        value={value}
        onChange={onChange}
        restrictions={restrictions && restrictions[id.toUpperCase()]}
        handleChangePlus={handleChangePlus}
        handleChangeMinus={handleChangeMinus}
        isMinusButtonDisabled={isMinusButtonDisabled}
        isPlusButtonDisabled={isPlusButtonDisabled}
      />
    </FieldContainer>
  </Wrapper>
)

export default InputNumberElement
